import fetch from '../utils/fetch'

export function getQualificationBasic (query) {
  return fetch({
    url: '/qualification/list',
    method: 'get',
    params: query,
  })
}
export function getItemsBasic (query) {
  return fetch({
    url: '/qualification/item/list',
    method: 'get',
    params: query,
  })
}
export function getJyfw(query) {
  return fetch({
    url: '/qualification/jyfw/list',
    method: 'get',
    params: query,
  })
}
export function editDian(query) {
  return fetch({
    url: '/qualification/update',
    method: 'put',
    data: query
  })
}
export function editShang(query) {
  return fetch({
    url: '/qualification/items/update',
    method: 'put',
    data: query
  })
}
export function getQualificationBasicDetail (query) {
  return fetch({
    url: '/qualification/list/detail',
    method: 'get',
    params: query,
  })
}
export function getQualificationDetail(query) {
  return fetch({
    url: '/qualification/detail/list',
    method: 'get',
    params: query,
  })
}
export function getCzLogs(query) {
  return fetch({
    url: '/qualification/log',
    method: 'get',
    params: query,
  })
}
export function updateMenu(query) {
  return fetch({
    url: '/wechat/menu',
    method: 'patch',
    data: query
  })
}


// WEBPACK FOOTER //
// ./src/api/qualification.js